import React from 'react'
import { useField, useFormikContext } from 'formik'
import { Select, MenuItem, styled } from '@mui/material'
import classNames from 'classnames'
import styles from './SelectField.module.scss'

const StyledSelect = styled(Select)`
  & .MuiSelect-select {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.palette.text.primary};
    padding-left: 0;
  }
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 10px;
    color: black;
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px gray solid;
    box-shadow: 0 0 0 4px white;
  }
`

interface SelectInputProps {
  name: string
  label: string
  options: { label: string; value: string }[]
  onChange?: (value: string) => void
  value: any
  disabled: boolean
}

const SelectInput: React.FC<SelectInputProps> = ({
  name,
  label,
  options,
  onChange,
  value,
  disabled = false,
}) => {
  const { setFieldValue } = useFormikContext()
  const [field] = useField(name)
  const inputClasses = classNames(styles.input)
  const inputFieldClasses = classNames(styles.field)
  const handleChange = (event: any) => {
    const selectedValue = event.target.value as string
    setFieldValue(name, event.target.value as string)
    if (onChange) {
      onChange(selectedValue)
    }
  }

  return (
    <div className={inputFieldClasses}>
      <StyledSelect
        value={value || field.value || 'no value'}
        onChange={handleChange}
        label={label}
        className={inputClasses}
        fullWidth={true}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        disabled={disabled}
      >
        <MenuItem disabled={true} key={'test'} value={'no value'}>
          {'Choose option'}
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </StyledSelect>
    </div>
  )
}

export default SelectInput
